'use client';

import { useEffect } from 'react';
import { SplashScreen } from 'src/components/loading-screen';
import { useRouter } from 'src/routes/hooks';
import { useAuthContext } from '../hooks';
import { paths } from 'src/routes/paths';
import PropTypes from 'prop-types';
export function ManagerGuard({ children, allowedRoles = ['ADMIN', 'MANAGER'] }) {
  const router = useRouter();

  const { user, loading } = useAuthContext();

  useEffect(() => {
    if (loading) {
      return;
    }

    if (!user) {
      router.replace(paths.auth.jwt.signIn);
      return;
    }

    // Check if user has required role
    const userRole = user.role?.toUpperCase();
    const hasPermission = allowedRoles.some((role) => role.toUpperCase() === userRole);

    if (!hasPermission) {
      router.replace(paths.page403);
      return;
    }
  }, [user, loading, router, allowedRoles]);

  if (loading) {
    return <SplashScreen />;
  }

  if (!user) {
    return <SplashScreen />;
  }

  const userRole = user.role?.toUpperCase();
  const hasPermission = allowedRoles.some((role) => role.toUpperCase() === userRole);

  if (!hasPermission) {
    return <SplashScreen />;
  }

  return children;
}

ManagerGuard.propTypes = {
  children: PropTypes.node,
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
};
